import { render, staticRenderFns } from "./deliveryGoods.vue?vue&type=template&id=3eedee34&scoped=true"
import script from "./deliveryGoods.vue?vue&type=script&lang=js"
export * from "./deliveryGoods.vue?vue&type=script&lang=js"
import style0 from "./deliveryGoods.vue?vue&type=style&index=0&id=3eedee34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedee34",
  null
  
)

export default component.exports